import { AmplitudeFlagKeys } from 'types/amplitudeFlags';

import useIsExperimentActive from 'components/Amplitude/useIsExperimentActive';

export const ROUTES = {
  NEW_ESTIMATE: '/new',
  FIRST_TIME_STEPS: '/first_time_use/steps',
  FIRST_TIME_INTRODUCTION: '/first_time_use/introduction',
  ESTIMATE_DETAILS: '/:id',
  DEFAULT_ESTIMATE_SETTINGS: '/default_estimate_settings',
  ESTIMATE_CUSTOMER_VIEW: '/customer_view',
  ESTIMATE_EMAIL_AND_SMS: '/email_and_sms',
  ESTIMATE_EXPIRATION_DATE: '/expiration_date',
  ESTIMATE_TEMPLATES: '/estimate_templates',
  USER_ACCOUNT_ESTIMATE_SETTINGS: () => {
    const isSettingsWithLeftRailActive = useIsExperimentActive(AmplitudeFlagKeys.settingsWithLeftRail);
    return isSettingsWithLeftRailActive
      ? '/app/settings/default_estimate_settings/customer_view'
      : '/pro/account/default_estimate_settings/customer_view';
  },
};
